"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Globe = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M13.004002,17 C14.7578789,17 16.3576788,16.3456 17.5852926,15.2796 L16.1535768,13.8486 C15.2911456,14.5536 14.2046023,15 13.004002,15 C10.2416208,15 8.00150075,12.761 8.00150075,10 C8.00150075,8.8 8.44172086,7.7076 9.14707354,6.8456 L7.71435718,5.4146 C6.64982491,6.6426 6.00050025,8.247 6.00050025,10 C6.00050025,13.866 9.13606803,17 13.004002,17 Z M13.004002,6 C10.7938969,6 9.002001,7.791 9.002001,10 C9.002001,12.209 10.7938969,14 13.004002,14 C15.2141071,14 17.006003,12.209 17.006003,10 C17.006003,7.791 15.2141071,6 13.004002,6 Z M12.0035018,20 L12.0035018,17.9316949 C8.05542503,17.4395378 5,14.0793422 5,10 C5,7.971 5.76238119,6.1176 7.0070035,4.7066 C7.22911456,4.4566 7.46423212,4.2216 7.71435718,3.9996 L9.85442721,6.1386 C10.7168584,5.4336 11.8034017,5 13.004002,5 C15.7673837,5 18,7.239 18,10 C18,11.2 17.5662831,12.2796 16.8609305,13.1416 L19,15.2796 C18.7788894,15.5306 18.5437719,15.7656 18.2926463,15.9866 C16.881941,17.2316 15.034017,18 13.004002,18 L13.004002,20 L15,20 L15,21 L10.0025013,21 L10.0025013,20 L12.0035018,20 Z" })));
};
Globe.displayName = 'Globe';
exports.default = Globe;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Globe.js.map